import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useMemo } from 'react';
import invariant from 'invariant';
import { styled, StyleSheet, StylesProvider, text, padding } from '@rexlabs/styling';
import { TextInput } from '@rexlabs/text-input';
import VividClearIcon from '@rexlabs/icons/clear.svg';
import EmptyArrowIcon from '@rexlabs/icons/medium/arrow-down-outline.svg';
import FilledArrowIcon from '@rexlabs/icons/medium/arrow-down-filled.svg';
import EmptyCircleIcon from '@rexlabs/icons/medium/circle-outline.svg';
import FilledCircleIcon from '@rexlabs/icons/medium/circle-filled.svg';
import ChevronDownIcon from '@rexlabs/icons/medium/chevron-down.svg';
import { useDownshiftContext } from '../../../../core';
import TextSelectInput from './text';
import TagMultiSelectInput from './multi';
import TagSingleSelectInput from './single';

function DefaultSuffix(_ref) {
  var isClearable = _ref.isClearable,
      inputValue = _ref.inputValue,
      multi = _ref.multi,
      shouldEnableInput = _ref.shouldEnableInput,
      selectedItem = _ref.selectedItem,
      shouldAddFreeformValue = _ref.shouldAddFreeformValue,
      isSearchable = _ref.isSearchable;

  if (isClearable && inputValue.length > 0) {
    if (multi || !multi && !selectedItem) {
      return /*#__PURE__*/React.createElement(ClearIcon, null);
    }
  }

  if (multi || !shouldEnableInput || !selectedItem) {
    if (shouldAddFreeformValue) {
      if (isSearchable) {
        return /*#__PURE__*/React.createElement(EmptyCircleIcon, null);
      }

      return /*#__PURE__*/React.createElement(EmptyArrowIcon, null);
    }

    if (isSearchable) {
      return /*#__PURE__*/React.createElement(FilledCircleIcon, null);
    }

    if (shouldEnableInput) {
      return /*#__PURE__*/React.createElement(FilledArrowIcon, null);
    }

    return /*#__PURE__*/React.createElement(ChevronDownIcon, null);
  }

  return null;
}

var defaultStyles = StyleSheet({
  clearIcon: {
    cursor: 'pointer'
  }
});

function ClearIconBase(_ref2) {
  var s = _ref2.styles,
      props = _objectWithoutProperties(_ref2, ["styles"]);

  var _useDownshiftContext = useDownshiftContext(),
      setState = _useDownshiftContext.setState;

  var handleClearInputValue = React.useCallback(function (event) {
    setState({
      inputValue: ''
    });
    event.preventDefault();
    event.stopPropagation();
  }, [setState]);
  return /*#__PURE__*/React.createElement(VividClearIcon, _extends({}, props, s('clearIcon'), {
    onClick: handleClearInputValue
  }));
}

var ClearIcon = styled(defaultStyles)(ClearIconBase);

function BaseSelectInput(props) {
  var multi = props.multi,
      placeholder = props.placeholder,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$isClearable = props.isClearable,
      isClearable = _props$isClearable === void 0 ? true : _props$isClearable,
      _props$isSearchable = props.isSearchable,
      isSearchable = _props$isSearchable === void 0 ? false : _props$isSearchable,
      _props$isFilterable = props.isFilterable,
      isFilterable = _props$isFilterable === void 0 ? false : _props$isFilterable,
      shouldAddFreeformValue = props.shouldAddFreeformValue,
      Value = props.Value,
      PrefixProp = props.Prefix,
      _props$Suffix = props.Suffix,
      SuffixProp = _props$Suffix === void 0 ? DefaultSuffix : _props$Suffix,
      meta = props.meta;

  var _useDownshiftContext2 = useDownshiftContext(),
      inputValue = _useDownshiftContext2.inputValue,
      selectedItem = _useDownshiftContext2.selectedItem,
      selectedItems = _useDownshiftContext2.selectedItems,
      getInputProps = _useDownshiftContext2.getInputProps,
      getToggleButtonProps = _useDownshiftContext2.getToggleButtonProps;

  var shouldEnableInput = isSearchable || isFilterable || shouldAddFreeformValue;
  React.useEffect(function () {
    invariant(!(isSearchable && isFilterable), "Base select can not have both 'isSearchable' and 'isFilterable' props as true. Please choose only one.");
  }, [isFilterable, isSearchable]);
  var containerProps = {};

  if (!disabled && !shouldEnableInput) {
    containerProps = getToggleButtonProps({
      tabIndex: 0
    });
  }

  var hasSelectedItem = multi && selectedItems.length > 0 || !multi && selectedItem;
  var shouldReducePadding = shouldEnableInput && hasSelectedItem;
  var tokens = useMemo(function () {
    return {
      textInput: _objectSpread(_objectSpread(_objectSpread({
        cursor: !shouldEnableInput ? 'default' : undefined,
        height: multi ? 'auto' : undefined
      }, text.tokens({
        target: 'select.textInput',
        lineHeight: function lineHeight() {
          return '2.4rem';
        }
      })), padding.tokens({
        target: 'select.textInput',
        y: function y() {
          return '0.6rem';
        },
        x: function x(_ref3) {
          var token = _ref3.token;
          return shouldReducePadding ? '0.6rem' : token('spacing.s');
        }
      })), {}, {
        width: multi ? 'auto' : '100%',
        input: {
          width: multi ? 'auto' : '100%'
        }
      })
    };
  }, [shouldReducePadding, multi, shouldEnableInput]);
  var Prefix = useMemo(function () {
    return PrefixProp ? function () {
      return /*#__PURE__*/React.createElement(PrefixProp, _extends({}, props, {
        multi: multi,
        placeholder: placeholder,
        disabled: disabled,
        isClearable: isClearable,
        isSearchable: isSearchable,
        isFilterable: isFilterable,
        shouldEnableInput: shouldEnableInput,
        shouldAddFreeformValue: shouldAddFreeformValue,
        Value: Value,
        meta: meta,
        inputValue: inputValue,
        selectedItem: selectedItem,
        selectedItems: selectedItems
      }));
    } : null;
  }, [PrefixProp, props, multi, placeholder, disabled, isClearable, isSearchable, isFilterable, shouldEnableInput, shouldAddFreeformValue, Value, meta, inputValue, selectedItem, selectedItems]);
  var Suffix = useMemo(function () {
    return SuffixProp ? function () {
      return /*#__PURE__*/React.createElement(SuffixProp, _extends({}, props, {
        multi: multi,
        placeholder: placeholder,
        disabled: disabled,
        isClearable: isClearable,
        isSearchable: isSearchable,
        isFilterable: isFilterable,
        shouldEnableInput: shouldEnableInput,
        shouldAddFreeformValue: shouldAddFreeformValue,
        Value: Value,
        meta: meta,
        inputValue: inputValue,
        selectedItem: selectedItem,
        selectedItems: selectedItems
      }));
    } : null;
  }, [SuffixProp, props, multi, placeholder, disabled, isClearable, isSearchable, isFilterable, shouldEnableInput, shouldAddFreeformValue, Value, meta, inputValue, selectedItem, selectedItems]);
  return /*#__PURE__*/React.createElement(StylesProvider, {
    tokens: tokens
  }, /*#__PURE__*/React.createElement(TextInput, _extends({
    meta: meta
  }, getInputProps({
    disabled: disabled,
    placeholder: placeholder,
    containerProps: containerProps,
    Prefix: Prefix,
    Suffix: Suffix
  })), function (inputProps) {
    var sharedProps = _objectSpread(_objectSpread({}, inputProps), {}, {
      Value: Value
    });

    if (shouldEnableInput) {
      return multi ? /*#__PURE__*/React.createElement(TagMultiSelectInput, sharedProps) : /*#__PURE__*/React.createElement(TagSingleSelectInput, sharedProps);
    } else {
      return /*#__PURE__*/React.createElement(TextSelectInput, sharedProps);
    }
  }));
}

export default BaseSelectInput;